import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import { Card, Classes, Icon, NonIdealState} from '@blueprintjs/core';
import axios from 'axios';
import styles from './index.module.less';
import classes from 'classnames';

const PaySuccess = () => {
  const params = useParams();
  const [hasUnionId, setHasUnionId] = useState(false);
  const [status, setStatus] = useState(0);
  const [user, setUser] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const [courseList, setCourseList] = useState([]);
  useEffect(() => {
    axios.get('/api/wx/is_login').then((response) => {
      const { code, data } = response.data;
      if (code === 0) {
        if (data.has_unionid === false) {
          window.location.href = 'http://api.py2fun.com/wx/passport?scope=snsapi_userinfo&next_url=' + encodeURIComponent(window.location.href);
        } else {
          setHasUnionId(true);
        }
      }
    });
  }, []);
  useEffect(() => {
    if (!hasUnionId) {
      return;
    }
    if (!params.orderId) {
      return;
    }
    axios.get('/api/mall/order_info', {
      params: {
        order_uuid: params.orderId
      }
    }).then((response) => {
      const { code, data } = response.data;
      if (code === 0) {
        const { status, wx_user, wx_sub_qrcode, course_infos } = data;
        setStatus(status);
        setUser(wx_user);
        setQrCode(wx_sub_qrcode);
        setCourseList(course_infos);
      }
    })
  }, [hasUnionId, params]);
  const renderUserInfo = () => {
    if (user === null) {
      return null;
    }
    return (
      <div className={styles.userInfo}>
        <img className={styles.avatar} src={user.headimgurl} alt=""/>
        <h5 className={classes(styles.nickname, Classes.HEADING)}>{user.nickname}</h5>
      </div>
    )
  };
  const renderOrderStatus = () => {
    if (status === 0) {
      return (
        <NonIdealState icon={<Icon icon='search' iconSize='64' />} title='状态查询中' />
      )
    }
    if (status >= 210) {
      return (
        <NonIdealState icon={<Icon icon='endorsed' iconSize='64' color="#3DCC91" />} title='购买成功' />
      )
    } else {
      return (
        <NonIdealState icon={<Icon icon='endorsed' iconSize='64' color="#FF7373" />} title={`支付失败，状态码：${status}`} />
      )
    }
  };
  const renderCourseList = () => {
    if (status >= 210) {
      return (
        <Card className={styles.courseInfo} elevation={0}>
          <h4 className={Classes.HEADING}>我的课程信息</h4>
          <Card>
            {renderUserInfo()}
            {courseList.map(course => (
              <div key={course.id} className={styles.course}>
                <div className={classes(Classes.TEXT_MUTED, Classes.RUNNING_TEXT)}>{course.name}</div>
                <Icon icon='small-tick' color='#3DCC91' />
              </div>
            ))}
          </Card>
        </Card>
      )
    }
    return null;
  };
  return (
    <div className={styles.page}>
      {renderOrderStatus()}
      {renderCourseList()}
      <Card className={styles.startSteps} elevation={0}>
        <h4 className={Classes.HEADING}>完成开课准备</h4>
        <Card>
          <h5 className={Classes.HEADING}>步骤一：关注公众号，领取福利</h5>
          <p className={classes(Classes.TEXT_MUTED, Classes.RUNNING_TEXT)}>长按下方二维码扫描，即可关注公众号。或者微信搜索【夸克编程】后，点击进入公众号并关注。</p>
          <div className={styles.followImages}>
            <img src={qrCode} alt=""/>
          </div>
        </Card>
        <Card className={styles.step}>
          <h5 className={Classes.HEADING}>步骤二：添加专业老师微信</h5>
          <p className={classes(Classes.TEXT_MUTED, Classes.RUNNING_TEXT)}>关注公众号后，我们将为你推送专业老师的微信二维码，长按消息中的二维码即可添加老师微信。请务必添加老师微信，学习中遇到任何问题都可以联系老师进行答疑哦~</p>
        </Card>
        <Card className={styles.step}>
          <h5 className={Classes.HEADING}>步骤三：登录学习网站</h5>
          <p className={classes(Classes.TEXT_MUTED, Classes.RUNNING_TEXT)}>打开PC端网页浏览器（强烈推荐Chrome浏览器），输入网址study.pythontip.com，用微信扫一扫登录，即可开始学习。</p>
        </Card>
      </Card>
      <p className={classes(Classes.RUNNING_TEXT, styles.bottomTips)}>
        <blockquote className={Classes.BLOCKQUOTE}>请务必关注公众号以及添加老师，有任何问题都可咨询您的专属老师。</blockquote>
      </p>
      {/*<div>订单号：{params.orderId}</div>*/}
      {/*{renderUserInfo()}*/}
      {/*{renderOrderStatus()}*/}
      {/*<div>此处展示公众号二维码</div>*/}
      {/*<div>此处展示购买的课程</div>*/}
    </div>
  );
};

export default PaySuccess;
